import _ from 'lodash';
import React, { Component } from 'react';
import * as CLIntF from '../../../interfaces/classroomLessons';
import StudentFillInTheList from '../../classroomLessons/play/listBlanks';
import PromptField from './slideComponents/promptField';
import SlidePreview from './slideComponents/slidePreview';
import TextField from './slideComponents/textField';
import TitleField from './slideComponents/titleField';

interface CustomizeFillInTheListProps {
  question: CLIntF.QuestionData,
  updateQuestion: Function,
  clearSlide: Function,
  resetSlide: Function,
  questionIndex: number,
  incompletePrompt: Boolean
}

class CustomizeFillInTheList extends Component<CustomizeFillInTheListProps, {}>{
  constructor(props){
    super(props);

    this.handleTitleChange = this.handleTitleChange.bind(this)
    this.handlePromptChange = this.handlePromptChange.bind(this)
    this.handleInstructionsChange = this.handleInstructionsChange.bind(this)
    this.handleCuesChange = this.handleCuesChange.bind(this)
    this.handleNBlanks = this.handleNBlanks.bind(this)
    this.handleBlankLabelChange = this.handleBlankLabelChange.bind(this)
    this.updateQuestion = this.updateQuestion.bind(this)
  }

  updateQuestion(newVals, questionIndex) {
    this.props.updateQuestion(newVals, questionIndex)
  }

  handleTitleChange(e) {
    const newVals = _.merge({}, this.props.question)
    _.set(newVals, 'teach.title', e.target.value)
    this.updateQuestion(newVals, this.props.questionIndex)
  }

  handlePromptChange(e) {
    const newVals = _.merge({}, this.props.question)
    _.set(newVals, 'play.prompt', e)
    this.updateQuestion(newVals, this.props.questionIndex)
  }

  handleInstructionsChange(e) {
    const newVals = _.merge({}, this.props.question)
    _.set(newVals, 'play.instructions', e.target.value)
    this.updateQuestion(newVals, this.props.questionIndex)
  }

  handleBlankLabelChange(e) {
    const newVals = _.merge({}, this.props.question)
    _.set(newVals, 'play.blankLabel', e.target.value)
    this.updateQuestion(newVals, this.props.questionIndex)
  }

  handleCuesChange(e) {
    const newVals = _.merge({}, this.props.question)
    const formattedCues = e.target.value.split(',');
    _.set(newVals, 'play.cues', formattedCues)
    this.updateQuestion(newVals, this.props.questionIndex)
  }

  handleNBlanks(e) {
    const newVals = _.merge({}, this.props.question)
    const nBlanks = e.target.value.length > 0 ? Number(e.target.value) : e.target.value;
    _.set(newVals, 'play.nBlanks', nBlanks)
    this.updateQuestion(newVals, this.props.questionIndex)
  }

  render() {
    const { clearSlide, questionIndex, resetSlide, question, incompletePrompt, } = this.props
    const instructionsInputId = `instructions-${questionIndex}`
    const numberOfBlanksInputId = `numberOfBlanks-${questionIndex}`

    return (
      <div className="slide">
        <div className="form">
          <TitleField
            clearSlide={clearSlide}
            handleTitleChange={this.handleTitleChange}
            questionIndex={questionIndex}
            resetSlide={resetSlide}
            title={question.teach.title}
          />
          <PromptField
            handleTextChange={(e) => this.handlePromptChange(e)}
            incompletePrompt={incompletePrompt}
            questionIndex={questionIndex}
            reset={question.reset}
            showBlockquote={false}
            text={question.play.prompt}
          />
          <TextField
            handleChange={this.handleInstructionsChange}
            id={instructionsInputId}
            label="Instructions"
            optional
            value={question.play.instructions}
          />
          <TextField
            handleChange={this.handleNBlanks}
            id={numberOfBlanksInputId}
            label="Number of Blanks"
            value={question.play.nBlanks}
          />
        </div>
        <SlidePreview slideNumber={questionIndex}>
          <StudentFillInTheList data={question} />
        </SlidePreview>
      </div>
    )
  }

}

export default CustomizeFillInTheList
